import meetingInsightsStore from '../store/store';

export default function isFetchMeetingInsightsServicePending(meetingId: string): boolean {
    // True if there is already a pending service call going on, i.e the meeting id is in the service queue
    return meetingInsightsStore.pendingServiceQueue.indexOf(meetingId) >= 0;
}
